import { createFileRoute } from '@tanstack/react-router';
import { IdentityPage } from '@/features/tenant-admin/pages';

export const Route = createFileRoute('/tenant-admin/identity')({
  component: IdentityPage,
});
